import Loading from '@/common/components/atom/loading';
import type { SVGProps } from 'react';

export type Icon2IconProps = SVGProps<SVGSVGElement> & { title?: string };

// Keep existing imports and layout classes while sharing the patient loading indicator.
export function Icon2Icon(props: Icon2IconProps) {
  return <Loading width="1em" height="1em" {...props} />;
}

export default Icon2Icon;
